import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export const getUnionAnchorInfo = createAsyncThunk(
  'UnionData/getUnionAnchorInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/union_info_from_leader', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

/**
 * // type:1 公会内主播， type:2 公会外主播, id： 搜索用户的id
 * @param {{type: Number, id: Number}} params
 * @returns
 */
export const searchUnionAnchor = createAsyncThunk(
  'UnionData/searchUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_search_from_leader', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

/**
 * type: 1昨日,2本周,3本月,4上月
 * @param {{type: Number }} params
 * @returns
 */
export const getUnionAnchorList = createAsyncThunk(
  'UnionData/getUnionAnchorList',
  async (p: any, store: any) => {
    const sta = store.getState()
    const resp = await http.post('/live/union/anchor_rank_from_leader', {
      ...sta.env.deviceinfo,
      ...p,
      offset: sta.UnionData.offset,
      limit: 30,
    })
    return resp.data
  }
)
// 删除主播
export const deleteUnionAnchor = createAsyncThunk(
  'UnionData/deleteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/union/anchor_delete_from_leader',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const inviteUnionAnchor = createAsyncThunk(
  'UnionData/inviteUnionAnchor',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/anchor_add_from_leader', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const getAdminAnchorList = createAsyncThunk(
  'UnionData/getAdminAnchorList',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/union/manager_list_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)
export const setAdminAnchorByLeader = createAsyncThunk(
  'UnionData/setAdminAnchorByLeader',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/add_manager_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)
export const cancelAdminAnchorByLeader = createAsyncThunk(
  'UnionData/cancelAdminAnchorByLeader',
  async (p: any, store: any) => {
    const resp = await http.post('/live/union/cancel_manager_from_leader', {
      ...store.getState().env.deviceinfo,
      leader_mid: store.getState().env.deviceinfo.h_m,
      ...p,
    })
    return resp.data
  }
)

const initialState: {
  union_name?: string
  union_id?: number
  anchor_cnt?: number
  yesterday_income?: number
  month_income?: number
  female_ratio?: string
  list?: any[]
  more?: boolean
  offset?: number
  manager_list?: {
    mid: number
    avatar: string
    name: string
    show_id: string
  }[]
} = {}
export const UnionDataSlice = createSlice({
  name: 'UnionData',
  initialState,
  reducers: {
    clearUnionAnchorList: (state) => {
      Object.assign(state, {
        list: [],
        offset: 0,
      })
    },
    setUnionAnchorList: (state, action) => {
      const {list} = action.payload
      Object.assign(state, {
        list,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUnionAnchorInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
    builder.addCase(getUnionAnchorList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, {
        ...data,
        list: [...state.list, ...data.list],
        offset: state.offset + data.list.length,
      })
    })
    builder.addCase(getAdminAnchorList.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export const UnionDataAction = UnionDataSlice.actions
export default UnionDataSlice.reducer
